import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './Header.css'

type PageType = 'home' | 'blog' | 'books' | 'projects' | 'legacy'

interface HeaderProps {
  currentPage: PageType
}

const Header = ({ currentPage }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleNavigation = (page: PageType) => {
    const routes = {
      home: '/',
      blog: '/blog',
      books: '/books',
      projects: '/projects',
      legacy: '/legacy'
    }
    navigate(routes[page])
    setIsMenuOpen(false)
  }

  const formatDisplayDate = () => {
    const today = new Date()
    return today.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })
  }

  return (
    <header className={`header visible ${isMenuOpen ? 'mobile-menu-open' : ''}`}>
      <div className={`header-container ${isMenuOpen ? 'mobile-menu-open' : ''}`}>
        <nav className="nav-left">
          <ul className="nav-list">
            <li><button onClick={() => handleNavigation('blog')} className={`nav-link ${currentPage === 'blog' ? 'active' : ''}`}>Blog</button></li>
            <li><button onClick={() => handleNavigation('books')} className={`nav-link ${currentPage === 'books' ? 'active' : ''}`}>Books</button></li>
          </ul>
        </nav>
        
        <div className="nav-center">
          <button onClick={() => handleNavigation('home')} className="date-link">
            {formatDisplayDate()}
          </button>
        </div>
        
        <nav className="nav-right">
          <ul className="nav-list">
            <li><button onClick={() => handleNavigation('projects')} className={`nav-link ${currentPage === 'projects' ? 'active' : ''}`}>Projects</button></li>
            <li><button onClick={() => handleNavigation('legacy')} className={`nav-link ${currentPage === 'legacy' ? 'active' : ''}`}>Legacy</button></li>
          </ul>
        </nav>

        <button 
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  )
}

export default Header
